@if (datasetACS.ready.value) {
  <div id="customStyle" class="{{datasetACS.datasetConfig.datasetListStyle}}">
    <div class="content-header">
      @if (showTitle) {
        <h2>
          <span>{{datasetACS.datasetConfig.title | translate | titlecase}}</span>
          <!-- guida della schermata, stesso pattern del blocco integrazioni tour operator -->
          @if (datasetACS.datasetConfig.docLink) {
            <a
              class="material-icons"
              [href]='appService.getAbsolutePath(datasetACS.datasetConfig.docLink)'
              target="_blank"
              [title]="'Apri la guida' | translate"
              style="vertical-align: middle; margin-left: 8px; font-size: 22px; text-decoration: none;"
            >help</a>
          }
          <!-- spiegazione della schermata: tooltip, non un link alla guida -->
          @if (datasetACS.datasetConfig.titleTooltip) {
            <mat-icon
              [matTooltip]='datasetACS.datasetConfig.titleTooltip | translate'
              style="vertical-align: middle; margin-left: 8px; font-size: 22px; height: 22px; width: 22px; cursor: help;"
            >help_outline</mat-icon>
          }
          <!--
          <button class='ml-24' mat-icon-button color='accent' (click)='onAdd()' *ngIf='resourceACS.canCreate() && enableCreate'>
            <mat-icon>add</mat-icon>
          </button>
          -->
        </h2>
      }
      <div class="dividerLine"></div>
    </div>
    @if (assistantPricingLocked) {
      <assistant-managed-banner></assistant-managed-banner>
    }
    @if (showCreateForm) {
      <div class="m-24 fx-row fx-justify-center fx-items-start">
        <dataset-create
          (created)='reload();'
          [datasetCode]='datasetACS.datasetCode'
          [parentDatasetACS]='datasetACS'
        ></dataset-create>
      </div>
    }
    @if (viewConfig.showExportBtn && showExportBtn) {
      <div>
        <export-data-tool
          [viewConfig]="viewConfig"
          [datasetACS]="datasetACS"
        ></export-data-tool>
      </div>
    }
    @if (viewConfig.showRequestPackage) {
      <div>
        <request-package-tool
          [viewConfig]="viewConfig"
          [datasetACS]="datasetACS"
        ></request-package-tool>
      </div>
    }
    @switch (itemViewType) {
      @case (ItemViewTypes.TABLE) {
        <list-table-view
          [enableCreate]='enableCreate && !assistantPricingLocked'
          [enableEdit]='enableEdit'
          [enableDelete]='enableDelete'
          [enableActions]='enableActions'
          [elevate]='elevate'
          (pageChanged)='onPageChanged($event)'
          (filterChange)='onFilterChange($event)'
          [selectable]='selectable'
          [selection]='selection'
          [selectionBtnTxt]='selectionBtnTxt'
          [selectionBtnIcon]='selectionBtnIcon'
          (selected)='selectRecord($event)'
          [viewConfig]='viewConfig'
          [showPagination]='showPagination'
          [conditionalShowPaginationToolbar]='conditionalShowPaginationToolbar'
          [showSearchBar]='showSearchBar'
          [showHeaderToolbar]='showHeaderToolbar'
          [unsetParamFilters]='unsetParamFilters'
          [emitAdd]='emitAdd'
          [addButtonText]='addButtonText'
          (add)='onAdd()'
          [paginationResponse]='lastPaginationResponse'
          [socketEvent]='socketEvent'
          [tableStyle]='tableStyle'
          [filterStyle]='filterStyle'>
        </list-table-view>
      }
      @case (ItemViewTypes.CUSTOM) {
        <list-custom-view
          [enableCreate]='enableCreate && !assistantPricingLocked'
          [enableEdit]='enableEdit'
          [enableDelete]='enableDelete'
          [enableActions]='enableActions'
          [elevate]='elevate'
          (pageChanged)='onPageChanged($event)'
          [selectable]='selectable'
          [selection]='selection'
          (selected)='selectRecord($event)'
          [viewConfig]='viewConfig'
          [showPagination]='showPagination'
          [conditionalShowPaginationToolbar]='conditionalShowPaginationToolbar'
          [showSearchBar]='showSearchBar'
          [emitAdd]='emitAdd'
          [addButtonText]='addButtonText'
          (add)='onAdd()'
          (reloadDatasetList)='reload()'
          [paginationResponse]='lastPaginationResponse'>
        </list-custom-view>
      }
      @case (ItemViewTypes.CALENDAR) {
        <dataset-calendar-view
          [enableCreate]='enableCreate && !assistantPricingLocked'
          [enableEdit]='enableEdit'
          [enableDelete]='enableDelete'
          [enableActions]='enableActions'
          [elevate]='elevate'
          (pageChanged)='onPageChanged($event)'
          [selectable]='selectable'
          [selection]='selection'
          (selected)='selectRecord($event)'
          [viewConfig]='viewConfig'
          [showPagination]='showPagination'
          [conditionalShowPaginationToolbar]='conditionalShowPaginationToolbar'
          [showSearchBar]='showSearchBar'
          [emitAdd]='emitAdd'
          [addButtonText]='addButtonText'
          (add)='onAdd()'
          [paginationResponse]='lastPaginationResponse'>
        </dataset-calendar-view>
      }
      @default {
        <div>
          @if (datasetACS.loading.value) {
            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
          }
          @if (!datasetACS.loading.value && items) {
            @for (item of items; track item) {
              <div>
                <pre>{{item | json}}</pre>
              </div>
            }
          }
        </div>
      }
    }
  </div>
}
